import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";

import {
  initGA,
  initGoogleConsentMode,
  grantAnalyticsConsent,
} from "./utils/analytics";

import { initCookieConsent } from "./cookieConsent";

const GA_ID = "G-ZHGF9F3E95";

// 🔐 1️⃣ Consent Mode – PRIVZETO VSE ZAVRNJENO
initGoogleConsentMode();

// 📊 2️⃣ GA script se naloži v cookieless načinu
initGA(GA_ID);

// 🍪 3️⃣ Cookie banner (opt-in)
initCookieConsent(() => {
  grantAnalyticsConsent();
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);